import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Button, Card, Modal } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'

import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import axios, { all } from 'axios'
import { FaSyncAlt } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'

export default function FeesCollection() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '300px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { course_id, student_id } = useParams()
  const numericStudentId = student_id ? Number(student_id) : null

  useEffect(() => {
    console.log('Course ID:', course_id)
    console.log('Numeric Student ID:', numericStudentId)
  }, [])

  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [selectedFee, setSelectedFee] = useState(null)
  const [isCancelling, setIsCancelling] = useState(false)
  const [loading, setLoading] = useState(false)
  const [cancelledId, setCancelledId] = useState(null)
  // const [stid, setStId] = useState(null)
  const [feeStructure, setFeeStructure] = useState([])
  const [open, setOpen] = useState(false)
  const [openPayment, setOpenPayment] = useState(false)
  const [courseNameIs, setCourseNameIs] = useState('')
  const [selectedStudentName, setSelectedStudentName] = useState(null)
  const [
    selectedStudentNameByParams,
    setSelectedStudentNameByParams,
  ] = useState(null)

  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedStudentObj, setSelectedStudentObj] = useState(null)
  const [paymentData, setPaymentData] = useState({
    transaction_id: '',
    transaction_amount: '',
    transaction_date: '',
    fees_taken_by: '1',
    payment_method: '',
    discount: '',
  })

  const [selectedCourse, setSelectedCourse] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const navigate = useNavigate()
  useEffect(() => {
    console.log('useEffect triggered with:', {
      course_id,
      student_id,
      allStudentsLength: allStudents.length,
      coursesLength: courses.length,
    })

    if (!course_id && allStudents.length > 0) {
      const student = allStudents.find((s) => s.id === Number(student_id))
      if (student) {
        console.log('Student (profile view):', student?.name)
        setSelectedStudentNameByParams(student)
        setSelectedStudent(student?.id)
        setCurrentStudent(student)
        setOpen(true)

        ApiEndpoints.getAllFeesByStudentProfileId(student_id).then((res) => {
          const fees = res.data.data || []
          const pendingFees = fees.filter(
            (fee) =>
              fee.fees_status !== 'complete' && fee.fees_status !== 'cancel',
          )
          console.log('Pending fees (profile):', pendingFees)
          setFeeStructure(pendingFees)
        })
      }

      return // prevent running the other block
    }

    if (
      course_id &&
      student_id &&
      allStudents.length > 0 &&
      courses.length > 0
    ) {
      console.log('Setting selected course:', course_id)
      setSelectedCourse(course_id)

      // Fetch classes for this course
      ApiEndpoints.getAllClassesByCourseId(course_id).then((res) => {
        const fetchedClasses = res.data.data || []
        console.log('Fetched classes:', fetchedClasses)
        setClasses(fetchedClasses)

        const student = allStudents.find((s) => s.id === Number(student_id))
        console.log('Found student:', student)

        if (student) {
          const matchedClass = fetchedClasses.find(
            (cls) => cls.id === student.class_id,
          )
          console.log('Matched class for student:', matchedClass)

          if (matchedClass) {
            setSelectedClass(matchedClass.id)
            const filtered = allStudents.filter(
              (s) => s.class_id === matchedClass.id,
            )
            console.log('Filtered students for matched class:', filtered)
            setFilteredStudents(filtered)
            console.log('STUDENT BY PARAMS:', student?.name)

            setSelectedStudentNameByParams(student)
            setSelectedStudent(student?.id)
            setCurrentStudent(student)

            setOpen(true)

            ApiEndpoints.getAllFeesByStudentId(student_id, course_id).then(
              (res) => {
                const pendingFees = res.data.data.filter(
                  (fee) =>
                    fee.fees_status !== 'complete' &&
                    fee.fees_status !== 'cancel',
                )
                console.log('Pending fees:', pendingFees)
                setFeeStructure(pendingFees)
              },
            )
          }
        }
      })
    }
  }, [course_id, student_id, allStudents, courses])

  useEffect(() => {
    // If there are no route params, reset everything
    if (!course_id && !student_id) {
      setSelectedCourse('')
      setSelectedClass('')
      setSelectedStudent(null)
      setFilteredStudents([])
      setFeeStructure([])
      setOpen(false) // Close data table
    }
  }, [course_id, student_id])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => {
        console.log('Courses:', res.data.data)
        setCourses(res.data.data)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    const courseName = allStudents.forEach((st) => {
      const course = courses.find((cs) => cs.id === st.course_id)
      const existCourse = course?.name || ''
      console.log(`Student: ${st.name}, Course: ${existCourse}`)
      setCourseNameIs(existCourse)
    })
    console.log('Course Name:', courseName)
  }, [allStudents, courses])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        // setData(response.data.data)
        setAllStudents(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  const handleCourseChange = async (e) => {
    const courseId = e.target.value
    const selected = courses.find((course) => course._id === courseId)
    setSelectedCourse(selected || {})
    setSelectedCourse(courseId)
    setClasses([])
    setFilteredStudents([])
    // if (courseId) {
    //   const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
    //   setClasses(res.data.data)
    // }
    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            console.error('No classes found for this course.')
            setClasses([])
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setSelectedClass(classId)
    const filtered = allStudents.filter(
      (student) => student.class_id === Number(classId),
    )
    setFilteredStudents(filtered)

    if (classId) {
      const institueId = Cookies.get('institute_id')
      const headers = {
        institute_id: Number(institueId),
      }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class select:', res.data.data)
          setFilteredStudents(res.data.data)
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  // const handleStudentChange = async (e) => {
  //   const studentId = Number(e.target.value)
  //   const student = filteredStudents.find((s) => s.id === studentId)
  //   console.log('STUDENT SELECTED:', student)
  //   console.log('STUDENT NAME:', student.name)
  //   setSelectedStudentName(student?.name)
  //   setSelectedStudentObj(student)
  //   // setSelectedStudent(student)
  //   setSelectedStudent(studentId)

  //   setFeeStructure([])
  //   console.log('Student: ', student)
  //   setOpen(true)

  //   try {
  //     const res = await ApiEndpoints.getAllFeesByStudentId(studentId)
  //     console.log('last response:', res.data.data)
  //     setFeeStructure(res.data.data)
  //     const pendingFees = res.data.data.filter(
  //       (fee) => fee.fees_status == 'pending',
  //     )
  //     console.log('PENDING FEES:', pendingFees)
  //     setFeeStructure(pendingFees)
  //   } catch (error) {
  //     console.error(error.response?.data?.message)
  //   }
  // }

  const handleStudentChange = async (e) => {
    const studentId = Number(e.target.value)
    const student = filteredStudents.find((s) => s.id === studentId)

    if (!student) {
      console.warn('⚠️ Student not found for ID:', studentId)
      setSelectedStudent('')
      setSelectedStudentObj(null)
      setSelectedStudentName('')
      return
    }

    console.log('STUDENT SELECTED:', student)
    console.log('STUDENT NAME:', student.name)

    setSelectedStudentName(student.name)
    setSelectedStudentObj(student)
    setSelectedStudent(studentId)

    setFeeStructure([])
    setOpen(true)

    try {
      const res = await ApiEndpoints.getAllFeesByStudentId(
        studentId,
        selectedCourse,
      )
      console.log('last response:', res.data.data)
      const pendingFees = res.data.data.filter(
        (fee) => fee.fees_status === 'pending',
      )
      console.log('PENDING FEES:', pendingFees)
      setFeeStructure(pendingFees)
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  const inputHandler = (e) => {
    const { name, value } = e.target // Correct way to extract name and value
    setPaymentData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically updating the state field
    }))
    console.log('name', name, 'value', value)
  }

  const handlePay = async () => {
    if (!paymentData.payment_method) {
      toast.error('Please select a payment method')
      return
    }
    // const finalStudentId =
    //   selectedStudent ||
    //   selectedStudent.id ||
    //   feeStructure ||
    //   feeStructure.student_id // Adjust if structure differs

    // const finalStudentId = selectedStudent?.id || feeStructure
    const finalStudentId =
      typeof selectedStudent === 'object' && selectedStudent !== null
        ? selectedStudent.id
        : typeof selectedStudent === 'string' ||
          typeof selectedStudent === 'number'
        ? selectedStudent
        : typeof feeStructure === 'object' && feeStructure !== null
        ? feeStructure.student_id || feeStructure.id
        : typeof feeStructure === 'string' || typeof feeStructure === 'number'
        ? feeStructure
        : null

    if (!finalStudentId) {
      toast.error('Student ID is missing or invalid')
      return
    }

    const formattedDate = paymentData.transaction_date
      ? new Date(paymentData.transaction_date)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')
      : null
    try {
      const payload = {
        student_id: finalStudentId,
        fee_id: selectedFee.id,
        transaction_id: paymentData.transaction_id,
        transaction_amount: paymentData.transaction_amount,
        transaction_date: formattedDate,
        fees_taken_by: paymentData.fees_taken_by,
        payment_method: paymentData.payment_method,
        // discount: paymentData.discount || '0',
        discount: Number(paymentData.discount) || 0,
      }
      console.log('Payload', payload)
      const response = await ApiEndpoints.submitStudentFee(payload)
      toast.success(response.data.result)

      setFeeStructure((prevFees) =>
        prevFees.filter((fee) => fee.id !== selectedFee.id),
      )

      setOpenPayment(false)
      setPaymentData({
        transaction_id: '',
        transaction_amount: '',
        transaction_date: '',
        fees_taken_by: '1',
        discount: '',
      })
      setSelectedFee(null)
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1000)
    } catch (error) {
      toast.error(error.response?.data?.result || 'Payment failed')
    }
  }
  const handleTakeFees = (feeItem) => {
    const today = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD

    setSelectedFee(feeItem)
    setPaymentData({
      transaction_id: '',
      transaction_amount: feeItem.amount,
      payment_method: '',
      transaction_date: today,
      fees_taken_by: '1',
      discount: feeItem.discount || '',
    })
    setOpenPayment(true)
  }

  const [blinkColor, setBlinkColor] = useState('red')

  useEffect(() => {
    const interval = setInterval(() => {
      setBlinkColor((prevColor) => (prevColor === 'red' ? 'blue' : 'red'))
    }, 500)

    return () => clearInterval(interval) // cleanup
  }, [])

  const handleSendRemider = async (feeItem) => {
    const user = Cookies.get('user')
    console.log('Token:', user)
    const parsedUser = user ? JSON.parse(user) : null
    const token = parsedUser?.token
    const payload = {
      student_id: feeItem.student_id,
      fee_id: feeItem.id,
    }
    console.log('Payload during send reminder:', payload)
    try {
      const response = await axios.post(
        BASE_URL+'/send-fee-reminder',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(response.data.result)
    } catch (error) {
      toast.error(error.response?.data?.result)
    }
  }

  const handleRefresh = () => {
    setCourses([])
    setClasses([])
    setFilteredStudents([])
    setFeeStructure([])
    setSelectedStudent(null)
    setSelectedFee(null)
    setSelectedCourse([])
    setOpen(false)
    setCurrentStudent(null)
    navigate('/TakeFees')
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)

    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
      } catch (err) {
        console.error('Failed to parse user cookie', err)
      }
    }

    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        setAllStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }

  const handleConfirmCancel = async () => {
    if (!selectedFee) return
    setIsCancelling(true)
    const userCookie = Cookies.get('user')
    let token = null

    try {
      const user = JSON.parse(userCookie)
      token = user.token
      console.log('TOKEN:', token)

      const response = await axios.post(
        BASE_URL+`/cancel-fee?fee_id=${selectedFee.id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      )
      console.log('Cancel response:', response.data.message)
      toast.success(response.data.message)
      setShowCancelModal(false)
      // let newData = feeStructure.map((obj, i) => {
      //   if (i == cancelledId) {
      //     obj.fees_status = 'cancel'
      //     return obj
      //   } else {
      //     return obj
      //   }
      // })
      const newData = feeStructure.filter((_, i) => i !== cancelledId)
      setFeeStructure(newData)

      console.log(newData)

      // setTimeout(() => {
      //   window.location.reload()
      // }, 1000)
    } catch (error) {
      console.error(error.response?.data?.message)
    } finally {
      setIsCancelling(false)
    }
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">
            Take Fees{' '}
            {currentStudent && (
              <>
                from{' '}
                <span className="text-warning">
                  {(currentStudent?.name || selectedStudent?.name) && (
                    <>
                      <span className="text-warning">
                        {(currentStudent?.name || selectedStudent?.name)
                          ?.charAt(0)
                          .toUpperCase() +
                          (currentStudent?.name || selectedStudent?.name)
                            ?.slice(1)
                            .toLowerCase()}
                      </span>
                    </>
                  )}{' '}
                </span>
              </>
            )}
          </h2>
        </div>

        {!student_id && (
          <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
            <Col md={3}>
              <Form.Group className="text-start fw-bold mb-0">
                <Form.Label>Select Course</Form.Label>
                {/* <Form.Select value={selectedCourse} onChange={handleCourseChange}>
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select> */}
                <Typeahead
                  id="course-select"
                  labelKey="name"
                  onChange={(selected) => {
                    const course = selected[0]
                    if (course) {
                      handleCourseChange({ target: { value: course.id } })
                    } else {
                      handleCourseChange({ target: { value: '' } })
                    }
                  }}
                  options={courses}
                  placeholder="Select Course"
                  selected={courses.filter(
                    (cs) => cs.id === Number(selectedCourse),
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="text-start fw-bold mb-0">
                <Form.Label>Select Class</Form.Label>
                {/* <Form.Select value={selectedClass} onChange={handleClassChange}>
                <option value="">Select Class</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.class_name}
                  </option>
                ))}
              </Form.Select> */}
                <Typeahead
                  id="class-select"
                  labelKey="class_name"
                  onChange={(selected) => {
                    const cls = selected[0]
                    if (cls) {
                      handleClassChange({ target: { value: cls.id } })
                    } else {
                      handleClassChange({ target: { value: '' } })
                    }
                  }}
                  options={classes}
                  placeholder="Select Class"
                  selected={classes.filter(
                    (cs) => cs.id === Number(selectedClass),
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="text-start fw-bold mb-0">
                <Form.Label>Select Student</Form.Label>
                {/* <Form.Select
                onChange={handleStudentChange}
                value={selectedStudent || ''} // Just the ID
              >
                <option value="">Select Student</option>
                {filteredStudents.map((student) => (
                  <option key={student.id} value={student.id}>
                    {student.name} - {student.admission_number}
                  </option>
                ))}
              </Form.Select> */}
                <Typeahead
                  id="student-select"
                  labelKey={(option) =>
                    `${option.name} - ${option.admission_number}`
                  }
                  onChange={(selected) => {
                    const student = selected[0]
                    if (student) {
                      handleStudentChange({ target: { value: student.id } })
                    } else {
                      handleStudentChange({ target: { value: '' } })
                    }
                  }}
                  options={filteredStudents}
                  placeholder="Select Student"
                  selected={
                    selectedStudent
                      ? filteredStudents.filter(
                          (st) => st.id === Number(selectedStudent),
                        )
                      : []
                  }
                />
              </Form.Group>
            </Col>
            <Col className="d-flex justify-content-md-end justify-content-start">
              <Button
                variant="outline-primary"
                onClick={handleRefresh}
                title="Refresh"
              >
                <FaSyncAlt /> Refresh
              </Button>
            </Col>
          </Row>
        )}

        {/* Student Details */}
        {((open && selectedStudent) || (open && numericStudentId)) && (
          <Card className="p-4 mt-4 shadow-sm border-0 text-start">
            <h5 className="fw-bold text-primary">
              👨‍🎓 Fees Detail of{' '}
              {/* {selectedStudent.name &&
                'of ' +
                  selectedStudent.name.charAt(0).toUpperCase() +
                  selectedStudent.name.slice(1).toLowerCase()} */}
              {selectedStudentNameByParams?.name?.toUpperCase() ||
                selectedStudentName?.toUpperCase() ||
                '-'}
            </h5>

            {feeStructure.length > 0 ? (
              <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
                <Thead className="bg-dark text-white">
                  <Tr className="bg-secondary rounded">
                    <Th>Fee Name</Th>
                    <Th>Course</Th>
                    <Th>Amount</Th>
                    <Th>Start Date</Th>
                    <Th>End Date</Th>
                    <Th>Fees Status</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {feeStructure.map((feeItem, index) => {
                    // })
                    return (
                      <Tr key={index}>
                        <Td>
                          {feeItem.fees_name.charAt(0).toUpperCase() +
                            feeItem.fees_name.slice(1)}
                        </Td>
                        <Td>{feeItem.course_name || courseNameIs}</Td>
                        <Td>₹ {feeItem.amount}</Td>

                        <Td>
                          {new Date(feeItem.start_date).toLocaleDateString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            },
                          )}
                        </Td>
                        <Td>
                          {new Date(feeItem.end_date).toLocaleDateString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            },
                          )}
                        </Td>

                        <Td>
                          {feeItem.fees_status.charAt(0).toUpperCase() +
                            feeItem.fees_status.slice(1)}
                        </Td>

                        <Td className=" text-center mb-4">
                          <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                            <Button
                              variant="success"
                              // onClick={() => setOpenPayment(true)}
                              onClick={() => handleTakeFees(feeItem)}
                            >
                              Take Fees
                            </Button>
                            <Button
                              className="btn btn-danger"
                              variant="Danger"
                              onClick={() => {
                                setSelectedFee(feeItem)
                                setCancelledId(index)
                                setShowCancelModal(true)
                              }}
                            >
                              Cancel Fees
                            </Button>
                            <Button
                              className="btn btn-info "
                              variant="Info"
                              onClick={() => handleSendRemider(feeItem)}
                            >
                              Send Reminder
                            </Button>
                          </div>
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            ) : (
              <p className="text-danger fw-bold mt-3">No Fees Found</p>
            )}
          </Card>
        )}

        <Modal show={openPayment} onHide={() => setOpenPayment(false)} centered>
          <Modal.Header closeButton className="bg-secondary text-white">
            <Modal.Title>💰 Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="g-3">
              {/* Transaction ID */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Select
                    name="payment_method"
                    value={paymentData.payment_method}
                    onChange={inputHandler}
                    required
                  >
                    <option value="">Select</option>
                    <option value="cash">Cash</option>
                    <option value="online">Online</option>
                    <option value="cheque">Cheque</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group>
                  <Form.Label>
                    {paymentData.payment_method === 'online'
                      ? 'Transaction ID'
                      : paymentData.payment_method === 'cheque'
                      ? 'Cheque ID'
                      : 'Transaction / Cheque ID'}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={
                      paymentData.payment_method === 'online'
                        ? 'Enter Transaction ID'
                        : paymentData.payment_method === 'cheque'
                        ? 'Enter Cheque ID'
                        : 'Select a payment method first'
                    }
                    name="transaction_id"
                    value={paymentData.transaction_id}
                    onChange={inputHandler}
                    disabled={
                      paymentData.payment_method !== 'online' &&
                      paymentData.payment_method !== 'cheque'
                    }
                  />
                </Form.Group>
              </Col>

              {/* Transaction Amount */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Transaction Amount</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Enter Amount"
                    name="transaction_amount"
                    value={paymentData.transaction_amount}
                    onChange={inputHandler}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Discount</Form.Label>
                  <Form.Control
                    type="text"
                    name="discount"
                    value={paymentData.discount}
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
              {/* Transaction Date */}
              <Col xs={12}>
                <Form.Group>
                  <Form.Label>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="transaction_date"
                    value={paymentData.transaction_date}
                    onChange={inputHandler}
                  />
                </Form.Group>
              </Col>
            </Row>
            <p
              className="fw-bold"
              style={{
                color: blinkColor,
                marginTop: '5px',
                marginBottom: '-5px',
                letterSpacing: '2px',
              }}
            >
              Please ensure to collect money.
            </p>
          </Modal.Body>

          {/* Buttons */}
          <Modal.Footer>
            <Button variant="danger" onClick={() => setOpenPayment(false)}>
              Close
            </Button>
            <Button variant="success" onClick={handlePay}>
              Receive Now
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showCancelModal && selectedStudent && (
        <Modal
          size="lg"
          show={showCancelModal}
          onHide={() => setShowCancelModal(false)}
          centered
        >
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title
              className="text-white fw-bold"
              style={{ letterSpacing: '1px' }}
            >
              Confirm Cancellation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2 fw-semibold" style={{ letterSpacing: '2px' }}>
              Are you sure you want to cancel the fee payment for: <br />
              <div>
                <br />
                <strong>Student:</strong>
                <span className="fw-semibold">
                  {' '}
                  {selectedStudentNameByParams?.name?.toUpperCase() ||
                    selectedStudentName?.toUpperCase() ||
                    '-'}
                </span>
                <br />
                <strong>Fees Name:</strong>
                <span className="fw-semibold">
                  {' '}
                  {selectedFee?.fees_name?.toUpperCase() || '-'}
                </span>

                <br />
                <span style={{ letterSpacing: '2px' }}>
                  <strong className="mt-2 ">Amount:</strong>
                  <span className="text-danger fw-bold">
                    {' '}
                    ₹ {selectedFee?.amount || 'N/A'}
                  </span>{' '}
                </span>
              </div>
            </p>
            <hr />
            <p
              // className="text-muted fw-semibold"
              style={{
                color: blinkColor,
                marginTop: '5px',
                marginBottom: '10px',
                letterSpacing: '2px',
              }}
            >
              Once cancelled, this fee record will no longer be visible or
              available for further actions.
            </p>
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => setShowCancelModal(false)}
                disabled={isCancelling}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                disabled={isCancelling}
                onClick={handleConfirmCancel}
              >
                {isCancelling ? 'Cancelling...' : 'Confirm Cancel'}
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      )}
    </div>
  )
}
